import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {isNullOrUndefined} from 'util';

import { AuthService } from '../../core/services/auth.service';

@Injectable()
export class FileUploadService {

  private params = new HttpParams().set('UseAuth', 'true');

  constructor(
    private http: HttpClient,
    private authService: AuthService) {
  }

  getFileRouteUrl(filename, system_type) {
    console.log("system_type=");
    console.log(system_type);
    if (system_type == 'onboarding') {
      console.log("onboarding path");
      return window.location.origin  + '/api/ob_fileupload/' + filename + '?token=' + this.authService.getToken();
    } else { //VMS
      return window.location.origin + '/api/fileupload/' + filename + '?token=' + this.authService.getToken();
    }
  }

  getPresignedPutUrl(filename: string, filetype: string, system_type: string): Promise<any> {
    console.log("system_type2=");
    console.log(system_type);
    const data = {
      file_name: filename,
      file_type: filetype
    }
    if (system_type === 'onboarding') {
      return this.http.post('/api/ob_fileupload/presigned', data, {params: this.params})
      .toPromise()
      .then(res => {
        return res['data'];
      });
    } else { //VMS
      console.log("VMS PATH")
      return this.http.post('/api/fileupload/presigned', data, {params: this.params})
        .toPromise()
        .then(res => {
          return res['data'];
        });
    }
  }
}
